module.exports = __webpack_public_path__ + "static/NickShanos-6d364c5650fa112ca5f902d86abdba81.png";